import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/menu/Home.vue";
import ShoppingCartPage from "@/views/menu/ShoppingCartPage.vue";
import OrderResult from '@/views/menu/OrderResult'
import store from "@/store/portal.js"

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Home",
		component: Home,
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/shopping-cart-page",
		name: "ShoppingCartPage",
		component: ShoppingCartPage,
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/order-result",
		name: "Order Result",
		component: OrderResult,
		meta: {
			requiresAuth: true,
			hasHeader:false
		}
	},
	{
		path: "/my-account",
		name: "My-account",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import("@/views/menu/MyAccount.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/checkout",
		name: "Checkout",
		component: () =>
			import("@/views/menu/Checkout.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/my-orders",
		name: "My-orders",
		component: () =>
			import("@/views/menu/MyOrders.vue"),
		meta: {
			requiresAuth: true,
			hasHeader:true
		}
	},
	{
		path: "/404",
		alias: "*",
		name: "not-found",
		component: () => import("@/views/menu/NotFound.vue")
	},
	{
		path: "/orderStatus/:orderId",
		name: "OrderStatus",
		component: ()=> import("@/views/menu/ShortOrderStatus.vue"),
		meta: {
			byPass:true, 
			requiresAuth: false,
			hasHeader:false,
			byPassForClose:true
		}
	},
	{
		path: "/pendingOrderStatus/:pendingOrderId",
		name: "pendingOrderStatus",
		component: ()=> import("@/views/menu/PendingOrderStatus.vue"),
		meta: {
			byPass:true, 
			requiresAuth: false,
			hasHeader:false,
			byPassForClose:true
		}
	}
];

const router = new VueRouter({
	mode: "hash",
	routes	
});

router.beforeEach((to, from, next) => {
	//console.log(from.name, to.name)

	let allowNext = store.getters.orders === undefined || store.getters.orders._id === undefined || to.name == "Order Result"
	if(to.name === "not-found"){
		history.back()
		next(false)		
	}else if(allowNext){
		console.log("toPage",to)
		next()
	}else{
		next(false)
	}

	/*let route = store.getters.getRouteFromLocalStorage
	//console.log(route, to.name, from);
	if(to.matched.some(record => record.meta.requiresAuth) && route !== to.name && from.name !== to.name){
	   if(route){		   
		   next(false)
		   router.replace({name: route})		   
	   } else{
		  next();	 	 
	   }
	}else{
		next()
	}*/

})
export default router;
